import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  searchingRcpt: false,
  rcptReportStr: false,
  validatingOTP: false,
  jasperRptStr: "",
  foundReceipt: {},
  receiptCreated: {},
  successMsg: {},
  otpValid: false,
  otpResult: {},
  rcptObj:{},
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action",
  validatingOTP: "validatingOTP",
  searchingRcpt: "searchRcpt",
  rcptReportStr: "rcptRptStr"
};
  

const receiptSlice = createSlice({
  name: 'receiptSlice',
  initialState:initialState,
  reducers: {
      catchError: (state, action) => {
        state.lastError = `${action.type}: ${action.payload.error}`;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = false;
        } else if (action.payload.callType === callTypes.searchingRcpt) {
          state.searchingRcpt = false;
        } else if (action.payload.callType === callTypes.rcptReportStr) {
          state.rcptReportStr = false;
        } else if (action.payload.callType === callTypes.validatingOTP) {
          state.validatingOTP = false;
        } else {
          state.actionsLoading = false;
        }
      },
      startCall: (state, action) => {
        state.lastError = null;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = true;
        } else if (action.payload.callType === callTypes.searchingRcpt) {
          state.searchingRcpt = true;
        } else if (action.payload.callType === callTypes.rcptReportStr) {
          state.rcptReportStr = true;
        } else if (action.payload.callType === callTypes.validatingOTP) {
          state.validatingOTP = true;
        } else {
          state.actionsLoading = true;
        }
      },
      receiptFound: (state, action) => {
        state.listLoading = false;
        state.searchingRcpt = false;
        state.lastError = null;
        state.foundReceipt = action.payload.receipt;
        state.jasperRptStr = action.payload.pdfString;
      },
      receiptCreated: (state, action) => {
        state.listLoading = false;
        state.lastError = null;
        state.receiptCreated = action.payload.receiptCreated;
      },
      otpSent: (state, action) => {
        state.actionsLoading = false;
        state.lastError = null;
        state.successMsg = action.payload;
      },
      otpValidated: (state, action) => {
        state.actionsLoading = false;
        state.otpResult = action.payload.result;
        state.rcptObj = action.payload.rcptObj;
        if(action.payload.result.status === 200){
          state.otpValid = true;
        } else {
          state.otpValid = false;
        }
        state.lastError = null;
        state.validatingOTP = false;
      },
      generatedReportStr: (state, action) => {
        state.actionsLoading = false;
        state.jasperRptStr = action.payload;
        state.rcptReportStr = false;
        state.lastError = null;
      },
      reset: (state, action) => {
        state.listLoading = false;
        state.actionsLoading = false;
        state.searchingRcpt = false;
        state.rcptReportStr = false;
        state.validatingOTP = false;
        state.jasperRptStr = "";
        state.foundReceipt = {};
        state.receiptCreated = {};
        state.successMsg = {};
        state.otpValid = false;
        state.otpResult = {};
        state.rcptObj ={};
        state.lastError = null;
      }       
    }
});

export const {actions} = receiptSlice;
export const {reducer} = receiptSlice;